import styled from "@emotion/styled";
import { Colors, Status } from "@snapchat/snap-design-system";

export interface BadgeAnimatedProps {
    status?: Status;
}

const statusBackgroundColor: Partial<Record<Status, Colors.ColorPalette>> = {
    [Status.WARNING]: Colors.Orange.V200,
    [Status.ERROR]: Colors.Red.V200,
};

export const BadgeAnimated = styled.div<BadgeAnimatedProps>`
    display: flex;
    align-items: center;
    justify-content: center;

    padding: 4px 8px;

    font-size: 11px;
    font-weight: 500;
    line-height: 12px;
    color: ${Colors.WHITE};
    letter-spacing: 0.2px;

    background: ${({ status = Status.WARNING }) =>
        statusBackgroundColor[status] ?? statusBackgroundColor[Status.WARNING]};
    border-radius: 4px;

    :hover,
    :focus {
        animation: shiver 300ms;
        animation-iteration-count: infinite;

        @media screen and (prefers-reduced-motion) {
            animation: none;
        }
    }

    @keyframes shiver {
        0% {
            transform: translate(0, 1px) rotate(0deg);
        }

        10% {
            transform: translate(1px, -2px) rotate(-1deg);
        }

        20% {
            transform: translate(-2px, -1px) rotate(1deg);
        }

        30% {
            transform: translate(3px, 2px) rotate(0deg);
        }

        40% {
            transform: translate(1px, 1px) rotate(2deg);
        }

        50% {
            transform: translate(-1px, 2px) rotate(-1deg);
        }

        60% {
            transform: translate(-2px, 1px) rotate(0deg);
        }

        70% {
            transform: translate(2px, 1px) rotate(-2deg);
        }

        80% {
            transform: translate(-1px, -1px) rotate(1deg);
        }

        90% {
            transform: translate(1px, 1px) rotate(0deg);
        }

        100% {
            transform: translate(2px, -2px) rotate(-1deg);
        }
    }
`;
